import React, { FC } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

import { ManualEnquiry } from '../model/ManualEnquiry';
import { getManualOverrides } from '../service/dao/EnquiryDao';

import LinkButton from '../component/LinkButton';
import EnquiryTable, { filterColumn, renderBookingStatusUpdated } from '../component/EnquiryTable/EnquiryTable';
import {Enquiry} from "../model/enquiry";

const ManualTable: FC<{ accessToken: string }> = ({ accessToken }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('manual.table.appid'),
      dataIndex: 'applicationId',
      render: (id: string, enquiry: ManualEnquiry) => (<LinkButton text={id} url={enquiry.applicationUrl} maxWidth={180} />),
      sorter: true,
      ...filterColumn(t('manual.table.appid'), 'applicationId'),
    },
    {
      title: t('manual.table.name'),
      dataIndex: 'name',
      render: (_: any, enquiry: ManualEnquiry) => `${enquiry.firstName} ${enquiry.surname}`,
      sorter: true,
      ...filterColumn(t('manual.table.name'), 'name'),
    },
    {
      title: t('manual.table.last.updated'),
      dataIndex: 'bookingStatusUpdated',
      render: (_: any, enquiry: Enquiry) => (renderBookingStatusUpdated(enquiry.evidenceProviders)),
      sorter: true,
    },
    {
      title: t('manual.table.links'),
      dataIndex: 'enquiryId',
      render: (id: string, enquiry: ManualEnquiry) => (
        <LinkButton
          title={enquiry.enquiryId}
          text={t('review.table.enquiry.history')}
          url={`${enquiry.engineUrl}${enquiry.enquiryId}`}
          maxWidth={320}
        />
      ),
    },
  ];

  return (
    <div className="manual-table">
      <EnquiryTable columns={columns} getEnquiries={getManualOverrides} expandable accessToken={accessToken} />
    </div>
  );
};

export default withAuthenticationRequired(ManualTable, {
});
